import Vue from "vue"
import VueMarkdown from "vue-markdown";

Vue.component('vue-markdown', VueMarkdown)